export default "__VITE_ASSET__NN2JZ7HX__"